//@ts-nocheck
import React, { useEffect, useRef } from "react";
import { Button, Checkbox, Switch } from "../../../../BP2Components";
import { DragSource, DropTarget } from "react-dnd";
import SimpleSelect from "../../../../BP2Components/Select/SimpleSelect";
import { getEmptyImage } from "react-dnd-html5-backend";

type ObjectItemProps = {
   connectDragSource: any;
   connectDropTarget: any;
   connectDragPreview: any;
   renderContent: (connectDragSource: any) => JSX.Element;
   customStyles?: React.CSSProperties;
   customClassName?: string;
   objectData: any;
   objectIndex: number;
   containerIndex: number;
   moveObject: (from: any, to: any) => void;
};

export const ItemTypes = {
   CONTAINER: "container",
   OBJECT: "object"
};

const containerSource = {
   beginDrag: (props) => ({ index: props.index })
};

const containerTarget = {
   drop: (props, monitor) => {
      const dragIndex = monitor.getItem().index;
      const hoverIndex = props.index;
      if (dragIndex !== hoverIndex) props.moveContainer(dragIndex, hoverIndex);
   }
};

const objectSource = {
   beginDrag: (props) => ({
      containerIndex: props.containerIndex,
      objectIndex: props.objectIndex
   })
};

const objectTarget = {
   drop: (props, monitor) => {
      const drag = monitor.getItem();
      const hover = {
         containerIndex: props.containerIndex,
         objectIndex: props.objectIndex
      };
      props.moveObject(drag, hover);
   }
};

// Single draggable object
const ObjectItem: React.FC<ObjectItemProps> = ({
   connectDragSource,
   connectDropTarget,
   connectDragPreview,
   renderContent,
   customStyles,
   customClassName
}) => {
   return connectDropTarget(
      connectDragPreview(
         <div className={`${customClassName ? customClassName : ""}`} style={customStyles}>
            {renderContent?.(connectDragSource)}
         </div>
      )
   );
};
export const DraggableObject = DropTarget(ItemTypes.OBJECT, objectTarget, (connect) => ({
   connectDropTarget: connect.dropTarget()
}))(
   DragSource(ItemTypes.OBJECT, objectSource, (connect) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview()
   }))(ObjectItem)
);

// Container with children
const ContainerItem = ({
   connectDragSource,
   connectDropTarget,
   children,
   container,
   renderContent,
   customClassName,
   moveContainer,
   index
}) =>
   connectDropTarget(
      <div className={`${customClassName ? customClassName : ""}`}>
         {renderContent?.(connectDragSource)}
         <div>{children}</div>
      </div>
   );

export const DraggableContainer = DropTarget(ItemTypes.CONTAINER, containerTarget, (connect) => ({
   connectDropTarget: connect.dropTarget()
}))(
   DragSource(ItemTypes.CONTAINER, containerSource, (connect) => ({
      connectDragSource: connect.dragSource()
   }))(ContainerItem)
);
